import Component from '@glimmer/component';
import nameSort from 'scaleflow/utils/nameSort';

export default class TeamsMultiAvatarPreviewComponent extends Component {
  get teams() {
    if (this.args.teams?.promise) return this.args.teams.content ?? [];
    return this.args.teams ?? [];
  }

  get sortedTeams() {
    const teams = this.teams.toSorted((a, b) =>
      nameSort(a.name, b.name, 'asc'),
    );
    if (this.args.showActiveTeamsOnly) return teams.filter((t) => t.active);
    return teams;
  }

  get firstTeam() {
    return this.sortedTeams[0];
  }

  get hasMoreThanOneTeam() {
    return this.sortedTeams.slice(1).length;
  }

  get restTeams() {
    return this.sortedTeams.slice(1).map((team) => team.name);
  }
}
